import React, { useEffect } from "react";
import "./Thank_you.css";

import Confirmation_Message from "./confirmation_message/Confirmation_Message";
import Dpu_alumni from "./dpu_alumni/Dpu_alumni";
import Hiring_Partners from "./hiring_partners/Hiring_Partners";

const Thank_you = () => {
  // useEffect(() => {
  //   // Load Facebook Pixel Script
  //   const loadFacebookPixel = () => {
  //     if (window.fbq) return;

  //     (function(f, b, e, v, n, t, s) {
  //       if (f.fbq) return;
  //       n = f.fbq = function() {
  //         n.callMethod
  //           ? n.callMethod.apply(n, arguments)
  //           : n.queue.push(arguments);
  //       };
  //       if (!f._fbq) f._fbq = n;
  //       n.push = n;
  //       n.loaded = true;
  //       n.version = "2.0";
  //       n.queue = [];
  //       t = b.createElement(e);
  //       t.async = true;
  //       t.src = v;
  //       s = b.getElementsByTagName(e)[0];
  //       s.parentNode.insertBefore(t, s);
  //     })(
  //       window,
  //       document,
  //       "script",
  //       "https://connect.facebook.net/en_US/fbevents.js",
  //     );

  //     window.fbq("init", "2360370587795642");
  //     window.fbq("track", "PageView");
  //   };

  //   loadFacebookPixel();

  //   // Google Ads Conversion Tracking
  //   const gtag_report_conversion = (url) => {
  //     const callback = function() {
  //       if (typeof url !== "undefined") {
  //         window.location = url;
  //       }
  //     };

  //     if (window.gtag) {
  //       window.gtag("event", "conversion", {
  //         send_to: "AW-17334514957/2uS9CJ2QzPAaEI3q3slA",
  //         value: 1.0,
  //         currency: "INR",
  //         event_callback: callback,
  //       });
  //     }
  //   };

  //   gtag_report_conversion();

  //   // Facebook Lead Event
  //   if (window.fbq) {
  //     window.fbq("track", "Lead", {
  //       value: 1,
  //       currency: "INR",
  //     });
  //   }

  //   // Second Google Ads Conversion
  //   if (window.gtag) {
  //     window.gtag("event", "conversion", {
  //       send_to: "AW-16713947906/4SA0CIeb2_MbEIK26qE-",
  //       value: 1.0,
  //       currency: "INR",
  //     });
  //   }
  // }, []);

  // useEffect(() => {

  //   // Google Ads Conversion Tracking
  //   const gtag_report_conversion = (url) => {
  //     const callback = function() {
  //       if (typeof url !== "undefined") {
  //         window.location = url;
  //       }
  //     };

  //     if (window.gtag) {
  //       window.gtag("event", "conversion", {
  //         send_to: "AW-16713947906/Qj_WCMzT4-gcEIK26qE-",
  //         value: 1.0,
  //         currency: "INR",
  //         event_callback: callback,
  //       });
  //     }

  //     return false;
  //   };

  //   gtag_report_conversion();

  //   // Facebook Lead Event
  //   if (window.fbq) {
  //     window.fbq("track", "Lead", {
  //       value: 1,
  //       currency: "INR",
  //     });
  //   }
  // }, []);

  useEffect(() => {
    const gtag_report_conversion = (url) => {
      const callback = function() {
        if (typeof url !== "undefined") {
          window.location = url;
        }
      };

      if (window.gtag) {
        window.gtag("event", "conversion", {
          send_to: "AW-16713947906/Qj_WCMzT4-gcEIK26qE-",
          value: 1.0,
          currency: "INR",
          event_callback: callback,
        });
      } else {
        // If gtag is not loaded, continue normally
        callback();
      }

      return false;
    };

    // Trigger Google Ads Conversion
    gtag_report_conversion();
  }, []);

  return (
    <section className="Thank_you_sec">
      <Confirmation_Message />
      <Dpu_alumni />
      <Hiring_Partners />
    </section>
  );
};

export default Thank_you;
